"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let id = 0;
const getId = () => `samba-ui-toggle-${id++}`;

const ToggleWrapper = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Toggle__ToggleWrapper",
  componentId: "sc-1hul93k-0"
})(["position:relative;"]);

const ToggleLabel = (0, _styledComponents2.default)(_Box2.default).attrs({ as: "label" }).withConfig({
  displayName: "Toggle__ToggleLabel",
  componentId: "sc-1hul93k-1"
})(["position:absolute;top:0;left:0;width:", ";height:", ";border-radius:", ";background:", ";cursor:pointer;&::after{content:\"\";display:block;border-radius:50%;box-shadow:0 0 0 1px ", ";width:", ";height:", ";margin:", ";background:#ffffff;transition:all 0.2s;}"], p => (0, _utils.variant)(p, { small: "32px", default: "40px" }), p => (0, _utils.variant)(p, { small: "16px", default: "20px" }), p => (0, _utils.variant)(p, { small: "16px", default: "20px" }), p => (0, _utils.palette)(p, "ink.400"), p => (0, _utils.alpha)((0, _utils.palette)(p, "ink.900"), 0.1), p => (0, _utils.variant)(p, { small: "12px", default: "16px" }), p => (0, _utils.variant)(p, { small: "12px", default: "16px" }), p => (0, _utils.variant)(p, { small: "2px", default: "2px" }));

const ToggleInput = (0, _styledComponents2.default)(_Box2.default).attrs({ as: "input", type: "checkbox", m: 0 }).withConfig({
  displayName: "Toggle__ToggleInput",
  componentId: "sc-1hul93k-2"
})(["opacity:0;z-index:1;border-radius:", ";width:", ";height:", ";&:checked + ", "{background:", ";&::after{margin-left:", ";}}&:focus + ", ",&:active + ", "{box-shadow:0 0 0 1px ", ";}&:disabled + ", "{background:", ";}"], p => (0, _utils.variant)(p, { small: "8px", default: "10px" }), p => (0, _utils.variant)(p, { small: "32px", default: "40px" }), p => (0, _utils.variant)(p, { small: "16px", default: "20px" }), ToggleLabel, p => (0, _utils.palette)(p, "blue.600"), p => (0, _utils.variant)(p, { small: "18px", default: "22px" }), ToggleLabel, ToggleLabel, p => (0, _utils.palette)(p, "blue.100"), ToggleLabel, p => (0, _utils.palette)(p, "ink.200"));

const Toggle = ({
  checked,
  onChange,
  id = getId(),
  label,
  variant,
  disabled
}) => _react2.default.createElement(
  ToggleWrapper,
  null,
  _react2.default.createElement(ToggleInput, {
    id: id,
    checked: checked,
    onChange: e => onChange(e.target.checked),
    variant: variant,
    disabled: disabled
  }),
  _react2.default.createElement(
    ToggleLabel,
    { htmlFor: id, variant: variant },
    label
  )
);

Toggle.propTypes = {
  checked: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  variant: _propTypes2.default.oneOf(["small", "default"])
};

Toggle.defaultProps = {
  variant: "default"
};

exports.default = Toggle;